module.exports = __webpack_public_path__ + "img/Newbie_Shield_02_Ranger.c8c04c81.png";